import * as Sentry from '@sentry/browser';
import { Component } from 'react';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import errorIcon from 'images/artwork/icons/error_reporting.svg';

export default class KnownIssueErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(/* error */) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      const { errorSource } = this.props;
      scope.setTag('error-source', errorSource);
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    const { errorSource } = this.props;
    const { eventId, hasError } = this.state;
    if (hasError) {
      return errorSource === 'draftjs-editor' ?
          <div css={({ spacing }) => ({ padding: spacing(2), textAlign: 'center' })}>
            <img height="20" src={errorIcon} width="20" />
            <Typography align="center" color="textSecondary" variant="body1">
              Sorry, something is not right here. Please try reloading the page!
            </Typography>
            <Button
              color="secondary"
              onClick={() => Sentry.showReportDialog({ eventId: eventId })}
              size="small"
              variant="text"
            >
              Report Feedback
            </Button>
          </div>
        : null;
    }
    return this.props.children;
  }
}
